import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class RequestService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.REQUEST = '/api/request';

        this.GET_LIST_FOR_USER = '/list/user/{userId}';
        this.GET_SENT_LIST_BY_USER_ID = '/list/sent/user/{userId}';
        this.ACCEPT = '/accept';
        this.DENY = '/deny';
    }

    /**
     * This class manages the REST Protocols for Requests.
     *
     * GET Requests:
     *     1) getRequestListForUser - GET By User ID
     *     2) getSentRequestListForUser - GET By User ID
     *
     * POST Requests:
     *     1) acceptRequest - Accept Request
     *     2) denyRequest - Deny Request
     *     3) createRequest - CREATE Request
     */

    async getRequestListForUser(userId) {
        try {
            let url = window.location.origin + this.REQUEST + this.GET_LIST_FOR_USER;
            url = url
                .replace('{userId}', userId);
            const requests = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return requests;
        } catch (err) {
            console.log(err);
        }
    }

    async getSentRequestListForUser(userId) {
        try {
            let url = window.location.origin + this.REQUEST + this.GET_SENT_LIST_BY_USER_ID;
            url = url
                .replace('{userId}', userId);
            const sentRequests = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return sentRequests;
        } catch (err) {
            console.log(err);
        }
    }

    async acceptRequest(request) {
        try {
            let url = window.location.origin + this.REQUEST + this.ACCEPT;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(request)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async denyRequest(request) {
        try {
            let url = window.location.origin + this.REQUEST + this.DENY;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(request)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
        } catch (err) {
            console.log(err);
        }
    }

    async createRequest(request){
        try{
            let url = window.location.origin + this.REQUEST;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const requestCreated = this.fetch(url, {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(request)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return requestCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async deleteRequest(requestMap){
        try{
            let url = window.location.origin + this.REQUEST;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const requestCreated = this.fetch(url, {
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(requestMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return requestCreated;
        }
        catch(err){
            console.log(err);
        }
    }
}

export default RequestService;
